export default __webpack_public_path__ + "static/media/korea.f5163d09.svg";